import httpClientService from '../httpClientService';
export default {
	getGridViews: () =>
		httpClientService.Get('/ReportBuilderModule/api/Reports/GridViews'),

	getReports: () => httpClientService.Get('/ReportBuilderModule/api/Reports'),
	getReport: (id) =>
		httpClientService.Get(`/ReportBuilderModule/api/Reports/${id}`),
	addReport: (item) =>
		httpClientService.Post(`/ReportBuilderModule/api/Reports/`, item),
	updateReport: (item) =>
		httpClientService.Put(
			`/ReportBuilderModule/api/Reports/${item.Id}`,
			item
		),
	deleteReport: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/Reports/${item.Id}`,
			item
		),
	reportPreview: (item) =>
		httpClientService.Post('/ReportBuilderModule/api/Reports/Data/', item),
	cloneReport: (item) =>
		httpClientService.Post(
			'/ReportBuilderModule/api/Reports/CloneReport',
			item
		),

	getReportFields: () =>
		httpClientService.Get('/ReportBuilderModule/api/ReportFields'),
	getReportField: (id) =>
		httpClientService.Get(`/ReportBuilderModule/api/ReportFields/${id}`),
	addReportField: (item) =>
		httpClientService.Post(`/ReportBuilderModule/api/ReportFields/`, item),
	updateReportField: (item) =>
		httpClientService.Put(
			`/ReportBuilderModule/api/ReportFields/${item.Id}`,
			item
		),
	deleteReportField: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/ReportFields/${item.Id}`,
			item
		),
	reorderReportFields: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/ReportFields/ReorderFields`,
			item
		),

	getReportFilters: () =>
		httpClientService.Get('/ReportBuilderModule/api/ReportFilters'),
	getReportFilter: (id) =>
		httpClientService.Get(`/ReportBuilderModule/api/ReportFilters/${id}`),
	addReportFilter: (item) =>
		httpClientService.Post(`/ReportBuilderModule/api/ReportFilters/`, item),
	updateReportFilter: (item) =>
		httpClientService.Put(
			`/ReportBuilderModule/api/ReportFilters/${item.Id}`,
			item
		),
	deleteReportFilter: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/ReportFilters/${item.Id}`,
			item
		),

	getReportSortings: () =>
		httpClientService.Get('/ReportBuilderModule/api/ReportSortings'),
	getReportSorting: (id) =>
		httpClientService.Get(`/ReportBuilderModule/api/ReportSortings/${id}`),
	addReportSorting: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/ReportSortings/`,
			item
		),
	updateReportSorting: (item) =>
		httpClientService.Put(
			`/ReportBuilderModule/api/ReportSortings/${item.Id}`,
			item
		),
	deleteReportSorting: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/ReportSortings/${item.Id}`,
			item
		),
	reorderReportSorting: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/ReportSortings/ReorderSortings`,
			item
		),

	getWorkbooks: () =>
		httpClientService.Get('/ReportBuilderModule/api/Workbooks'),
	getWorkbook: (id) =>
		httpClientService.Get(`/ReportBuilderModule/api/Workbooks/${id}`),
	addWorkbook: (item) =>
		httpClientService.Post(`/ReportBuilderModule/api/Workbooks/`, item),
	updateWorkbook: (item) =>
		httpClientService.Put(
			`/ReportBuilderModule/api/Workbooks/${item.Id}`,
			item
		),
	deleteWorkbook: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/Workbooks/${item.Id}`,
			item
		),
	cloneWorkbook: (item) =>
		httpClientService.Post(
			'/ReportBuilderModule/api/Workbooks/CloneWorkbook',
			item
		),

	downloadReport: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/Reports/Download/${item.Id}`
		),
	downloadWorkbook: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/Workbooks/Download/${item.Id}`
		),

	updatePreviewVisibility: (item) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/Reports/${item.reportId}/SetPreviewVisible?isVisible=${item.isVisible}`
		),
	getReportPreviews: () =>
		httpClientService.Get('/ReportBuilderModule/api/ReportPreview'),
	getAdminReportPreviews: () =>
		httpClientService.Get(
			'/ReportBuilderModule/api/ReportPreview/GetAdminReportPreviews'
		),

	getReportPreview: (reportId, gridViewId) =>
		httpClientService.Get(
			`/ReportBuilderModule/api/ReportPreview/${reportId}/gridView/${gridViewId}`
		),
	loadReportPreviewData: (payload) =>
		httpClientService.Post(
			`/ReportBuilderModule/api/ReportPreview/Data`,
			payload
		),

	updateColumns: (param1, param2) => {
		let data = { GridViewId: param1, Columns: param2 };
		return httpClientService.Post(
			'/ReportBuilderModule/api/GridViews/SetVisibleColumns',
			data
		);
	},
	insertReportPreview: (data) =>
		httpClientService.Post(`/ReportBuilderModule/api/ReportPreview`, data),
	updateGridView: (data) =>
		httpClientService.Put(`/ReportBuilderModule/api/GridViews`, data),
	downloadReportPreview: (payload) =>
		httpClientService.PostForExport(
			'/ReportBuilderModule/api/Export/ExportExcel',
			payload
		),
	deleteReportPreview: (item) =>
		httpClientService.Delete(
			`/ReportBuilderModule/api/ReportPreview/${item.ReportId}/gridView/${item.GridViewId}`
		),

	getProjectUsers: (id) =>
		httpClientService.Get(
			'/ReportBuilderModule/api/UserAssign/GetProjectUsers?id=' + id
		),

	getReportUsers: (id) =>
		httpClientService.Get(
			'/ReportBuilderModule/api/UserAssign/GetReportUsers?id=' + id
		),
	insertReportUser: (reportId, users) => {
		let data = { ReportId: reportId, Users: users };
		return httpClientService.Post(
			'/ReportBuilderModule/api/UserAssign/AddReportUser',
			data
		);
	},
	deleteReportUser: (reportId, users) => {
		let data = { ReportId: reportId, Users: users };
		return httpClientService.Delete(
			'/ReportBuilderModule/api/UserAssign/RemoveReportUser',
			data
		);
	},
};
